
import React, { Component } from 'react'

import Mobile from './mobile'
import Pc from './pc'
import {setWxShare} from './util/wxShare'

window.jwplayer.key="44Q5I+IeRJNSOKmj+UHDkKYQrWx3R2iz4Og48gAQJUKRwMOK"
const IsPC = () => {
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
    }
    return flag;
}
const is_mobile =!(IsPC())    
//  window.innerWidth < 800

// console.log('REACT_APP_ENV', process.env.REACT_APP_ENV);

class App extends Component {

    componentDidMount() {
        // wxShare
        function isWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        }
        if(isWeiXin()){
            setWxShare({
                title: 'Historical Map: Ukraine Crisis',
                desc: 'Looking back at the roots of the Russia-Ukraine conflict may help us figure out a path to peace.',
                site_link: 'https://news.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html',
                img_url: 'https://news.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/share_square.jpg',
                success: ()=>{
                    console.log('Share success!')
                },
                cancel: ()=>{
                    console.log('Share cancel!')
                }
            })
        }
    }

    render() {
        return (
        is_mobile
        ? <Mobile />
        : <Pc />
        );
    }
}

export default App;
